<template>
  <div class="md:max-w-full">
    <div class="max-w-6xl mx-auto md:w-full">
      <div class="p-5 rounded-md bg-stone-100" v-if="companyDetails">
        <div class="flex flex-col h-full mx-auto">
          <div class="items-center md:space-x-5 md:flex">
            <img
              v-if="companyDetails.photo"
              :src="companyDetails.photo"
              class="rounded-lg w-[200px] h-200px]"
              alt=""
            />
            <div
              v-else
              class="flex items-center justify-center font-bold text-white bg-black h-44 w-44 text-7xl"
            >
              {{ $getInitials(companyDetails.name) }}
            </div>

            <div class="flex flex-col justify-center">
              <p class="text-3xl font-bold text-black">
                {{ companyDetails.name }}
              </p>
              <div class="flex space-x-8">
                <p class="pt-3 font-light text-gray-400">
                  <span class="pr-2 font-normal text-black">{{
                    companyDetails.properties_count
                  }}</span>
                  <span class="text-sm text-gray-700">Active Listing</span>
                </p>
                <p class="pt-3 font-light text-gray-400">
                  <span class="pr-2 font-normal text-black">{{
                    companyDetails.number_of_agents
                  }}</span>
                  <span class="text-sm text-gray-700">Agents</span>
                </p>
              </div>
            </div>
          </div>
          <div class="flex mt-5">
            <p class="pr-2 font-light text-gray-400">Address:</p>
            <p>{{ companyDetails.address }}</p>
          </div>
          <div class="mt-10 md:flex md:justify-between">
            <p class="text-sm font-light text-gray-500">
              {{ companyDetails.name }}
            </p>
            <div class="flex flex-row space-x-5">
              <a
                :href="
                  'mailto:' +
                  companyDetails.email +
                  '?subject=Property Information  &body=Hi, I found your property with ref:' +
                  companyDetails.reference +
                  ' on hutloop. Please contact me. Thank you.!'
                "
                class="flex items-center justify-center h-10 p-2 space-x-2 text-sm bg-white border rounded-md md:text-base w-44 border-primary"
              >
                <EmailSvg
                  color="primary"
                  class="fill-primary"
                  height="4"
                  width="4"
                />
                <p class="font-medium text-primary">Email Company</p>
              </a>
              <a
                :href="'tel:' + companyDetails.phone"
                class="flex items-center justify-center h-10 p-2 space-x-2 text-sm bg-white border rounded-md md:text-base w-44 border-primary"
              >
                <CallSvg
                  color="primary"
                  class="fill-primary"
                  height="4"
                  width="4"
                />
                <p class="font-medium text-primary">Call Company</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { ref } from "vue";
import CallSvg from "@/components/svg/CallSvg.vue";
import EmailSvg from "@/components/svg/EmailSvg.vue";
// import WhatsAppSvg from "@/components/svg/WhatsAppSvg.vue";
export default {
  components: {
    CallSvg,
    EmailSvg,
    // WhatsAppSvg,
  },
  props: {
    companyDetails: Object,
  },
  setup() {},
};
</script>
